export default __webpack_public_path__ + "static/media/team4.b1486727.png";